import { Flex, Paper, Text } from '@mantine/core';
import PropTypes from 'prop-types';
import classes from './mortgageInfoBoxes.module.css';

const MortgageInfoBoxes = (props) => {
  const { boxes } = props;
  return (
    <Flex gap='sm'>
      {boxes.filter((box) => box.show !== false).map((box, index) => (
        <Paper
            key={index}
            style={{ borderTopColor: box.borderColor }}
            classNames={{ root: classes.boxInfo }}
      >
          <Flex direction='column' justify='center' align='center' gap='xs'>
            {box.icon}
            <Text size='sm'>{box.title}</Text>
            <Text fw='bold' c={box.color}>{box.value}</Text>
            {box.info && <Text size='sm'>{box.info}</Text>}
          </Flex>
        </Paper>
      ))}
    </Flex>
  );
};

MortgageInfoBoxes.propTypes = {
  boxes: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      info: PropTypes.string,
      icon: PropTypes.node,
      color: PropTypes.string,
      borderColor: PropTypes.string,
      show: PropTypes.bool,
    }),
  ).isRequired,
};

export default MortgageInfoBoxes;
